import { render, staticRenderFns } from "./IPrompt.vue?vue&type=template&id=ea7e3c50&scoped=true&"
import script from "./IPrompt.vue?vue&type=script&lang=js&"
export * from "./IPrompt.vue?vue&type=script&lang=js&"
import style0 from "./IPrompt.vue?vue&type=style&index=0&id=ea7e3c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7e3c50",
  null
  
)

export default component.exports
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QChip,QTooltip});
